import type { IsPositionReachableInOneTurn } from "./IsPositionReachableInOneTurn"

export default function byTotalCostAsc(a: IsPositionReachableInOneTurn, b: IsPositionReachableInOneTurn): number {
  return a.totalCost - b.totalCost
}
